/**
 * Temporary component that has the purpose of enabling compability between
 * Modern and Legacy.
 *
 * NOTE: This component should be removed once Legacy is fully deprecated
 */
import React from 'react';
import { Link as ReactRouterLink } from 'react-router-dom';
import { Link as ReduxLittleRouterLink } from 'redux-little-router';

export const RouterLink = (props: any) => {
  if (process.env.IS_LEGACY) {
    const { href, ...rest } = props;
    return <ReactRouterLink {...rest} to={href} />;
  }

  return <ReduxLittleRouterLink {...props} />;
};
try {
    // @ts-ignore
    RouterLink.displayName = "RouterLink";
    // @ts-ignore
    RouterLink.__docgenInfo = { "description": "", "displayName": "RouterLink", "props": {} };
    // @ts-ignore
    if (typeof STORYBOOK_REACT_CLASSES !== "undefined")
        // @ts-ignore
        STORYBOOK_REACT_CLASSES["src/components/RouterLink/index.tsx#RouterLink"] = { docgenInfo: RouterLink.__docgenInfo, name: "RouterLink", path: "src/components/RouterLink/index.tsx#RouterLink" };
}
catch (__react_docgen_typescript_loader_error) { }